import { Flex, HStack } from "@chakra-ui/react";
import { useGetOtcApiKeyQuery } from "apis";
import { IconButton, Layout, PageLoading, PageMotion } from "components";
import useAccessKey from "hooks/useAccessKey";
import { PageProps } from "interfaces";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

interface OTCCheckInProps extends PageProps {}

export default function OTCCheckIn(props: OTCCheckInProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const { setAccessKey } = useAccessKey();

  const { data, isSuccess, isLoading } = useGetOtcApiKeyQuery(undefined);

  useEffect(() => {
    if (isLoading) {
    } else if (isSuccess) {
      if (data?.accessKey) {
        setAccessKey(data.accessKey);
        navigate(`/${location.search}`);
      }
    }
  }, [isLoading, isSuccess, location?.search, data, navigate, setAccessKey]);

  return (
    <PageMotion key="OTCCheckIn" minH={{ base: "96vh", md: "98vh" }}>
      <Layout>
        <HStack w="100%">
          <Flex flex="1" />
          <PageLoading isLoading={isLoading || true} />

          <Flex flex="1" />
          <IconButton aria-label="more button" icon="moreVert" />
        </HStack>
      </Layout>
    </PageMotion>
  );
}
